import script from "./TrainersSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainersSection.vue?vue&type=script&setup=true&lang=js"

import "./TrainersSection.vue?vue&type=style&index=0&id=7dd2602a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dd2602a"]])

export default __exports__